module.exports = __webpack_public_path__ + "img/icon-yanbo.8e4c94ed.png";